export const integrations = [
  {
    id: 'okta',
    name: 'Okta',
    category: 'IdP',
    status: 'available',
    description: 'Identity provider with SSO, MFA, and lifecycle management capabilities.',
    capabilities: {
      read: ['Users', 'Groups', 'Applications', 'Logs', 'Factors'],
      write: ['User lifecycle', 'Group membership', 'App assignment', 'Factor enrollment']
    },
    authMethods: ['OAuth 2.0', 'API Token'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/okta'
  },
  {
    id: 'entra-id',
    name: 'Microsoft Entra ID',
    category: 'IdP',
    status: 'available',
    description: 'Azure Active Directory for identity and access management.',
    capabilities: {
      read: ['Users', 'Groups', 'Applications', 'Sign-in logs', 'Conditional Access'],
      write: ['User lifecycle', 'Group membership', 'App roles', 'License assignment']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '20 minutes',
    docsUrl: '/docs/integrations/entra-id'
  },
  {
    id: 'google-workspace',
    name: 'Google Workspace',
    category: 'IdP',
    status: 'available',
    description: 'Google identity and productivity suite integration.',
    capabilities: {
      read: ['Users', 'Groups', 'Organizational Units', 'Devices', 'Tokens'],
      write: ['User provisioning', 'Group membership', 'OU assignment', 'License management']
    },
    authMethods: ['OAuth 2.0', 'Service Account'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/google-workspace'
  },
  {
    id: 'bamboohr',
    name: 'BambooHR',
    category: 'HRIS',
    status: 'available',
    description: 'HR information system for employee data and lifecycle events.',
    capabilities: {
      read: ['Employees', 'Departments', 'Locations', 'Job titles', 'Terminations'],
      write: ['Custom fields']
    },
    authMethods: ['API Key'],
    setupTime: '10 minutes',
    docsUrl: '/docs/integrations/bamboohr'
  },
  {
    id: 'workday',
    name: 'Workday',
    category: 'HRIS',
    status: 'available',
    description: 'Enterprise HR and finance platform integration.',
    capabilities: {
      read: ['Workers', 'Organizations', 'Positions', 'Cost centers', 'Supervisory orgs'],
      write: ['Custom fields', 'Integration events']
    },
    authMethods: ['OAuth 2.0', 'API Credentials'],
    setupTime: '30 minutes',
    docsUrl: '/docs/integrations/workday'
  },
  {
    id: 'intune',
    name: 'Microsoft Intune',
    category: 'MDM',
    status: 'available',
    description: 'Mobile device management for Windows, macOS, iOS, and Android.',
    capabilities: {
      read: ['Devices', 'Compliance policies', 'Configuration profiles', 'Apps'],
      write: ['Device actions', 'Policy assignment', 'App deployment']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '20 minutes',
    docsUrl: '/docs/integrations/intune'
  },
  {
    id: 'jamf',
    name: 'Jamf Pro',
    category: 'MDM',
    status: 'available',
    description: 'Apple device management for macOS, iOS, and tvOS.',
    capabilities: {
      read: ['Computers', 'Mobile devices', 'Policies', 'Configuration profiles'],
      write: ['Device actions', 'Policy assignment', 'Group membership']
    },
    authMethods: ['API Token', 'OAuth 2.0'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/jamf'
  },
  {
    id: 'servicenow',
    name: 'ServiceNow',
    category: 'ITSM',
    status: 'available',
    description: 'IT service management with CMDB and workflow automation.',
    capabilities: {
      read: ['Incidents', 'Requests', 'Changes', 'CMDB', 'Users'],
      write: ['Ticket lifecycle', 'Work notes', 'Assignments', 'Custom fields']
    },
    authMethods: ['OAuth 2.0', 'Basic Auth'],
    setupTime: '25 minutes',
    docsUrl: '/docs/integrations/servicenow'
  },
  {
    id: 'jira-sm',
    name: 'Jira Service Management',
    category: 'ITSM',
    status: 'available',
    description: 'Atlassian service desk with workflows and automation.',
    capabilities: {
      read: ['Issues', 'Projects', 'Workflows', 'Users', 'Queues'],
      write: ['Issue lifecycle', 'Comments', 'Transitions', 'Custom fields']
    },
    authMethods: ['OAuth 2.0', 'API Token'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/jira-sm'
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    category: 'SaaS',
    status: 'available',
    description: 'CRM platform with user and license management.',
    capabilities: {
      read: ['Users', 'Profiles', 'Permission sets', 'Roles', 'Login history'],
      write: ['User provisioning', 'Profile assignment', 'Permission sets', 'License allocation']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '20 minutes',
    docsUrl: '/docs/integrations/salesforce'
  },
  {
    id: 'slack',
    name: 'Slack',
    category: 'SaaS',
    status: 'available',
    description: 'Team messaging with user and channel management.',
    capabilities: {
      read: ['Users', 'Channels', 'User groups', 'Access logs'],
      write: ['User provisioning', 'Channel membership', 'User group assignment', 'Deactivation']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '10 minutes',
    docsUrl: '/docs/integrations/slack'
  },
  {
    id: 'github',
    name: 'GitHub',
    category: 'SaaS',
    status: 'available',
    description: 'Code repository with team and access management.',
    capabilities: {
      read: ['Users', 'Teams', 'Repositories', 'Audit log', 'Org membership'],
      write: ['Team membership', 'Repository access', 'Org invitations', 'SSO management']
    },
    authMethods: ['OAuth 2.0', 'GitHub App'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/github'
  },
  {
    id: 'zoom',
    name: 'Zoom',
    category: 'SaaS',
    status: 'available',
    description: 'Video conferencing with user and license management.',
    capabilities: {
      read: ['Users', 'Meetings', 'Usage reports', 'Settings'],
      write: ['User provisioning', 'License assignment', 'Settings management']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '10 minutes',
    docsUrl: '/docs/integrations/zoom'
  },
  {
    id: 'crowdstrike',
    name: 'CrowdStrike',
    category: 'Security',
    status: 'available',
    description: 'Endpoint detection and response platform.',
    capabilities: {
      read: ['Hosts', 'Detections', 'Incidents', 'Vulnerabilities', 'Policies'],
      write: ['Host containment', 'Detection status', 'RTR commands']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '20 minutes',
    docsUrl: '/docs/integrations/crowdstrike'
  },
  {
    id: 'aws',
    name: 'AWS',
    category: 'Cloud',
    status: 'available',
    description: 'Amazon Web Services IAM and resource management.',
    capabilities: {
      read: ['IAM users', 'Roles', 'Policies', 'Groups', 'Access keys'],
      write: ['User lifecycle', 'Role assignment', 'Policy attachment', 'Access key rotation']
    },
    authMethods: ['IAM Role', 'Access Keys'],
    setupTime: '25 minutes',
    docsUrl: '/docs/integrations/aws'
  },
  {
    id: 'azure',
    name: 'Microsoft Azure',
    category: 'Cloud',
    status: 'available',
    description: 'Azure resource and identity management.',
    capabilities: {
      read: ['Subscriptions', 'Resource groups', 'RBAC assignments', 'Service principals'],
      write: ['RBAC assignment', 'Service principal management', 'Resource access']
    },
    authMethods: ['OAuth 2.0', 'Service Principal'],
    setupTime: '25 minutes',
    docsUrl: '/docs/integrations/azure'
  },
  {
    id: 'coupa',
    name: 'Coupa',
    category: 'Finance',
    status: 'beta',
    description: 'Procurement and spend management platform.',
    capabilities: {
      read: ['Users', 'Approvals', 'Spend data', 'Suppliers'],
      write: ['User provisioning', 'Approval workflows']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '30 minutes',
    docsUrl: '/docs/integrations/coupa'
  },
  {
    id: 'notion',
    name: 'Notion',
    category: 'SaaS',
    status: 'available',
    description: 'Workspace with team and access management.',
    capabilities: {
      read: ['Users', 'Workspaces', 'Pages', 'Databases'],
      write: ['User provisioning', 'Access management', 'Guest removal']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '10 minutes',
    docsUrl: '/docs/integrations/notion'
  },
  {
    id: 'figma',
    name: 'Figma',
    category: 'SaaS',
    status: 'available',
    description: 'Design tool with team and project access management.',
    capabilities: {
      read: ['Users', 'Teams', 'Projects', 'Files'],
      write: ['User provisioning', 'Team membership', 'Project access']
    },
    authMethods: ['OAuth 2.0'],
    setupTime: '10 minutes',
    docsUrl: '/docs/integrations/figma'
  },
  {
    id: 'datadog',
    name: 'Datadog',
    category: 'SaaS',
    status: 'available',
    description: 'Monitoring platform with user and team management.',
    capabilities: {
      read: ['Users', 'Teams', 'Roles', 'Dashboards'],
      write: ['User provisioning', 'Role assignment', 'Team membership']
    },
    authMethods: ['API Key', 'OAuth 2.0'],
    setupTime: '15 minutes',
    docsUrl: '/docs/integrations/datadog'
  }
];

export const categories = [
  { id: 'IdP', label: 'Identity Provider', description: 'SSO, MFA, and identity lifecycle' },
  { id: 'HRIS', label: 'HR Information System', description: 'Employee data and lifecycle events' },
  { id: 'MDM', label: 'Mobile Device Management', description: 'Device compliance and management' },
  { id: 'ITSM', label: 'IT Service Management', description: 'Ticketing and service desk' },
  { id: 'SaaS', label: 'SaaS Applications', description: 'Business applications' },
  { id: 'Security', label: 'Security Tools', description: 'EDR, SIEM, and security platforms' },
  { id: 'Cloud', label: 'Cloud Providers', description: 'AWS, Azure, GCP infrastructure' },
  { id: 'Finance', label: 'Finance & Procurement', description: 'Spend management and procurement' }
];

export const getIntegrationById = (id) => integrations.find(i => i.id === id);

export const getIntegrationsByCategory = (category) =>
  integrations.filter(i => i.category === category);

export const getAvailableIntegrations = () =>
  integrations.filter(i => i.status === 'available');

export const searchIntegrations = (query) => {
  const lowerQuery = query.toLowerCase();
  return integrations.filter(i =>
    i.name.toLowerCase().includes(lowerQuery) ||
    i.description.toLowerCase().includes(lowerQuery) ||
    i.category.toLowerCase().includes(lowerQuery)
  );
};
